var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1015 6.26622L7.09108 12.2766C5.72425 13.6435 3.50817 13.6435 2.14134 12.2766C0.774502 10.9098 0.774502 8.69372 2.14134 7.32688L8.15174 1.31647C9.06297 0.405251 10.5404 0.405251 11.4516 1.31647C12.3628 2.2277 12.3628 3.70508 11.4516 4.61631L5.67687 10.391C5.22126 10.8466 4.48257 10.8466 4.02695 10.391C3.57134 9.9354 3.57134 9.19671 4.02695 8.74109L9.09455 3.6735",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clip.0416f960e86b91ed1a765e6cbecc8aea.svg";